import React from 'react';
import PropTypes from 'prop-types';

import ResponsivePicture from '../../Elements/ResponsivePicture/ResponsivePicture';
import AudioPlayer from '../../Community/AudioPlayer/AudioPlayer';

import { breakpoints } from '../imageDefaults';
import { clipText } from '../helpers';
import { constructCn } from '../../../utilities/helperFunctions';

import './PodcastCard.scss';

const PodcastCard = ({
    wink,
    title,
    description,
    image,
    audioSrc,
    showAudioPlayer,
    location,
}) => {
    // no audio on feed for now but we can enable later if needed
    const audioPlayer =
        showAudioPlayer && audioSrc ? (
            <AudioPlayer audioSrc={audioSrc} />
        ) : null;

    const winkText = wink ? <div className="wink-label">{wink}</div> : null;

    const descriptionText = description ? (
        <div className="podcast-card-description">
            {clipText(description, 67)}
        </div>
    ) : null;

    const contentWrapperCn = constructCn(
        'content-wrapper',
        location === 'miniFeed' && 'full-width'
    );

    return (
        <div className="component-UnifiedPostCard-PodcastCard">
            <ResponsivePicture
                breakpoints={breakpoints}
                cloudinaryID={image.src}
                alt={image.alt}
            />
            {audioPlayer}
            <div className={contentWrapperCn}>
                {winkText}
                <div className="podcast-card-title">{clipText(title, 110)}</div>
                {descriptionText}
            </div>
        </div>
    );
};

PodcastCard.propTypes = {
    wink: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    audioSrc: PropTypes.string,
    showAudioPlayer: PropTypes.bool,
    image: PropTypes.exact({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
    }).isRequired,
    location: PropTypes.string.isRequired,
};

PodcastCard.defaultProps = {
    audioSrc: '',
    showAudioPlayer: false,
};

PodcastCard.displayName = 'PodcastCard';

export default PodcastCard;
